import type { MouseEventHandler } from 'react';

import classNames from 'classnames';

import { prefixUrlWithProtocol } from '@/utils/prefixUrlWithProtocol';

import BlueskyIcon from '../../socialsElement/components/BlueskyIcon';
import DiscordIcon from '../../socialsElement/components/DiscordIcon';
import FacebookIcon from '../../socialsElement/components/FacebookIcon';
import InstagramIcon from '../../socialsElement/components/InstagramIcon';
import LinkedinIcon from '../../socialsElement/components/LinkedInIcon';
import RssIcon from '../../socialsElement/components/RssIcon';
import TiktokIcon from '../../socialsElement/components/TiktokIcon';
import TwitterIcon from '../../socialsElement/components/TwitterIcon';
import YoutubeIcon from '../../socialsElement/components/YoutubeIcon';

import * as styles from '../Authors.css';
import type { TAuthorAttributes } from '../Authors.type';

interface Props {
  twitter_handle?: string;
  facebook_url?: string;
  instagram_url?: string;
  linkedin_url?: string;
  tiktok_url?: string;
  youtube_url?: string;
  discord_url?: string;
  bluesky_url?: string;
  rss_url?: string;
  className?: string;
  attributes: TAuthorAttributes;
}

const SIZE_OPTIONS = {
  '4': 'h-4 w-4',
  '5': 'h-5 w-5',
  '6': 'h-6 w-6',
  '7': 'h-7 w-7',
  '8': 'h-8 w-8',
  '9': 'h-9 w-9',
  '10': 'h-10 w-10',
  '11': 'h-11 w-11',
  '12': 'h-12 w-12',
};

const ALIGNMENT_OPTIONS = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
};

const Socials = ({
  twitter_handle,
  facebook_url,
  instagram_url,
  linkedin_url,
  tiktok_url,
  youtube_url,
  discord_url,
  bluesky_url,
  rss_url,
  attributes,
  className,
}: Props) => {
  const size: keyof typeof SIZE_OPTIONS = attributes?.cardSocialSize || ('4' as any);
  const sizeClass = SIZE_OPTIONS[size] || 'w-4 h-4';
  const alignment: keyof typeof ALIGNMENT_OPTIONS = attributes?.alignment || ('left' as any);
  const alignmentClass = ALIGNMENT_OPTIONS[alignment] || 'justify-start';

  const handleClick: MouseEventHandler<HTMLAnchorElement> = (e) => e.stopPropagation();

  return (
    <div className={classNames(styles.socials, 'flex flex-row gap-2 flex-wrap', alignmentClass, className)}>
      {twitter_handle && (
        <a target="_blank" rel="noreferrer" href={`https://x.com/${twitter_handle}`} onClick={handleClick}>
          <TwitterIcon className={classNames(sizeClass, 'color-inherit')} />
        </a>
      )}
      {linkedin_url && (
        <a target="_blank" rel="noreferrer" href={prefixUrlWithProtocol(linkedin_url)} onClick={handleClick}>
          <LinkedinIcon className={classNames(sizeClass, 'color-inherit')} />
        </a>
      )}
      {youtube_url && (
        <a target="_blank" rel="noreferrer" href={prefixUrlWithProtocol(youtube_url)} onClick={handleClick}>
          <YoutubeIcon className={classNames(sizeClass, 'color-inherit')} />
        </a>
      )}
      {tiktok_url && (
        <a target="_blank" rel="noreferrer" href={prefixUrlWithProtocol(tiktok_url)} onClick={handleClick}>
          <TiktokIcon className={classNames(sizeClass, 'color-inherit')} />
        </a>
      )}
      {facebook_url && (
        <a target="_blank" rel="noreferrer" href={prefixUrlWithProtocol(facebook_url)} onClick={handleClick}>
          <FacebookIcon className={classNames(sizeClass, 'color-inherit')} />
        </a>
      )}
      {instagram_url && (
        <a target="_blank" rel="noreferrer" href={prefixUrlWithProtocol(instagram_url)} onClick={handleClick}>
          <InstagramIcon className={classNames(sizeClass, 'color-inherit')} />
        </a>
      )}
      {discord_url && (
        <a target="_blank" rel="noreferrer" href={prefixUrlWithProtocol(discord_url)} onClick={handleClick}>
          <DiscordIcon className={classNames(sizeClass, 'color-inherit')} />
        </a>
      )}
      {bluesky_url && (
        <a target="_blank" rel="noreferrer" href={prefixUrlWithProtocol(bluesky_url)} onClick={handleClick}>
          <BlueskyIcon className={classNames(sizeClass, 'color-inherit')} />
        </a>
      )}
      {rss_url && (
        <a target="_blank" rel="noreferrer" href={prefixUrlWithProtocol(rss_url)} onClick={handleClick}>
          <RssIcon className={classNames(sizeClass, 'color-inherit')} />
        </a>
      )}
    </div>
  );
};

export default Socials;
